import {CustomSpineAnimation} from "./CustomSpineAnimation";

export class NumberFrameAnimation extends PIXI.Container {

    private static readonly NUMBER_FRAME_ANIMATION_CONFIG = {
        NAME: "numberFrameAnimation",
        STATES: {
            IDLE: "idle",
            HIGHLIGHT_0: "highlight0",
            HIGHLIGHT_REGULAR_NUMBER: "highlightRegularNumber",
        },
    };

    private animation: CustomSpineAnimation;
    private readonly BETS_BUTTONS_OFFSET_X = 83;
    private readonly BETS_BUTTONS_OFFSET_Y = 105;
    private readonly OFFSET_FROM_ZERO = 90;

    constructor() {
        super();
        this.createAndAddAnimation();
    }

    public highlightFrame(number: number): void {
        this.setAnimationPosition(number);
        if (number === 0) {
            this.animation.play(NumberFrameAnimation.NUMBER_FRAME_ANIMATION_CONFIG.STATES.HIGHLIGHT_0);
        } else {
            this.animation.play(NumberFrameAnimation.NUMBER_FRAME_ANIMATION_CONFIG.STATES.HIGHLIGHT_REGULAR_NUMBER);
        }
    }

    private setAnimationPosition(number: number): void {
        if (number === 0) {
            this.animation.position.x = 0;
            this.animation.position.y = this.BETS_BUTTONS_OFFSET_Y * 3 / 2;
        } else {
            this.animation.position.x = this.OFFSET_FROM_ZERO +
                Math.floor((number - 1) / 3) * this.BETS_BUTTONS_OFFSET_X;
            this.animation.position.y = (2.5 - (number - 1) % 3) * this.BETS_BUTTONS_OFFSET_Y;
        }
    }

    private createAndAddAnimation(): void {
        this.animation = new CustomSpineAnimation(NumberFrameAnimation.NUMBER_FRAME_ANIMATION_CONFIG.NAME);
        this.animation.play(NumberFrameAnimation.NUMBER_FRAME_ANIMATION_CONFIG.STATES.IDLE);
        this.addChild(this.animation);
    }
}



// WEBPACK FOOTER //
// ./src/app/NumberFrameAnimation.ts